import { getExtension } from './documentFormatters';

export const MAX_FILE_SIZE = 25 * 1024 * 1024;

export const ACCEPTED_MIME_TYPES = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg']
};

export const ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'png', 'jpg', 'jpeg'];

export const isAllowedFileType = (file) => {
  const fileType = file?.type;
  const extension = getExtension(file?.name);

  return Boolean(
    (fileType && Object.keys(ACCEPTED_MIME_TYPES).includes(fileType)) ||
    (extension && ALLOWED_EXTENSIONS.includes(extension))
  );
};
